var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(-1175 -375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19086",
    "data-name": "\\uADF8\\uB8F9 19086",
    transform: "translate(49.5 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_362",
    "data-name": "\\uC120 362",
    y1: 16,
    x2: 16,
    transform: "translate(1129.5 378.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_363",
    "data-name": "\\uC120 363",
    x1: 16,
    y1: 16,
    transform: "translate(1129.5 378.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24702",
    "data-name": "\\uC0AC\\uAC01\\uD615 24702",
    width: 24,
    height: 24,
    transform: "translate(1175 375)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopClose);
export default __webpack_public_path__ + "static/media/pop-close.4d19749e6afdec7f82156fd27d713b5e.svg";
export { ForwardRef as ReactComponent };